var intlTelInputItems = [];

App.prototype.intlTelInput = function () {
    var intlTelInputs = $('.intl-tel-input'), dialCode, requiredFixEl;

    $.each(intlTelInputs, function (key, el) {
        intlTelInputItems[key] = $(el);

        intlTelInputItems[key].intlTelInput(
            {
                initialCountry: "auto",
                separateDialCode: true,
                hiddenInput: $(el).data('realName'),
                geoIpLookup: function (success, failure) {
                    $.get("https://ipinfo.io", function () {
                    }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "TR";

                        success(countryCode);
                    });
                },
            }
        );

        intlTelInputItems[key].on("countrychange", function () {
            dialCode = intlTelInputItems[key].intlTelInput("getSelectedCountryData").dialCode;
            requiredFixEl = $(intlTelInputItems[key].data('requiredFix'));

            if (requiredFixEl) {
                if (typeof dialCode === "undefined") {
                    requiredFixEl.val('')
                } else {
                    requiredFixEl.val('true')
                    intlTelInputItems[key].val(intlTelInputItems[key].val().replace("+" + dialCode, ""))
                }
            }
        });

        intlTelInputItems[key].trigger("countrychange");

    });
}

const pages = [
    'basket-page',
    'auth-page'
];

pages.forEach((item) => App.prototype.pageDetector(item, App.prototype.intlTelInput))

App.prototype.manuallySetIntlTelInputValueForAjax = function () {
    $.each(intlTelInputItems, function (key, el) {
        $('[name="' + el.data('realName') + '"]').val(el.intlTelInput("getNumber"))
    });
}
